import {
  UPDATE_ACTION_TYPE,
  UPDATE_COUPON_STATUS,
  UPDATE_COUPON_LIST,
  UPDATE_CLUB_TABLE_LIST,
} from './constants'

const initState = {
  actionType: 1, // 1: 新建； 2：详情；3：修改
  clubList: [],
  clubTables: [], // 对应俱乐部的球台列表
  couponStatus: 1, // 显示什么类型的卡券 1. 正常；2. 过期；3.删除
  couponList: [], // 卡券列表
}

export default function (state = initState, action) {
  switch (action.type) {
    case UPDATE_ACTION_TYPE:
      return Object.assign({}, state, { actionType: action.payload })
    case UPDATE_COUPON_STATUS:
      return Object.assign({}, state, { couponStatus: action.payload })
    case UPDATE_COUPON_LIST:
      return Object.assign({}, state, { couponList: action.payload })
    case UPDATE_CLUB_TABLE_LIST:
      return Object.assign({}, state, { clubTables: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/CardManage/reduce.js